export * from '@primeuix/themes/lara/confirmpopup';
export { default } from '@primeuix/themes/lara/confirmpopup';
